import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {
  CACHE_SIZE_UNLIMITED,
  enableIndexedDbPersistence,
  getFirestore,
  initializeFirestore,
} from "firebase/firestore";
import toast from "react-hot-toast/headless";

const app = initializeApp({
  apiKey: import.meta.env.VITE_REACT_APP_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: import.meta.env.VITE_REACT_APP_FIREBASE_DATABASE_URL,
  projectId: import.meta.env.VITE_REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env
    .VITE_REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_REACT_APP_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_REACT_APP_FIREBASE_MEASUREMENT_ID,
});

const analytics = getAnalytics(app);

const firestoreDb = initializeFirestore(app, {
  cacheSizeBytes: CACHE_SIZE_UNLIMITED,
});

// Disable persistence because indexeddb has issues in Safari
/*
enableIndexedDbPersistence(firestoreDb).catch((error) => {
  if (error.code == "failed-precondition") {
    toast.error(
      "Multiple tabs open: Offline saving can only be enabled with a single tab open."
    );
    console.error(error);
  } else if (error.code == "unimplemented") {
    toast.error("Offline persistence not supported by this browser.");
    console.error(error);
  }
});
*/

export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;
